import { Component, OnInit } from '@angular/core';
import { OportunidadFactoring } from 'src/app/home/_models/oportunidad-factoring';
import { ProyectosHomeService } from 'src/app/home/_services/proyectos-home.service';
import { SharedModule } from 'src/app/_shared/_shared.module';
import { RouterModule } from '@angular/router';
import { PlatformService } from 'src/app/_services/platform.service';
import { DOMAIN_ENVIRONMENT } from 'src/app/_services/base.service';
import { SubiendoOportunidadesComponent } from 'src/app/_shared/bloque-loading/subiendo-oportunidades/subiendo-oportunidades.component';
import { SellosComponent } from 'src/app/factoring/shared/utils/sellos/sellos.component';
import { ProgressBarComponent } from 'src/app/_shared/bloque-ficha/progress-bar/progress-bar.component';


@Component({
  selector: 'app-home-factoring',
  templateUrl: './home-factoring.component.html',
  styleUrls: ['./home-factoring.component.scss'],
  standalone: true,
  imports: [
    SharedModule,
    RouterModule,
    SubiendoOportunidadesComponent,
    SellosComponent,
    ProgressBarComponent
  ]
})


export class HomeFactoringComponent implements OnInit
{
  isLoading: boolean = false;
  isPlatformFactoring: boolean = false;
  domainUrl: string;
  proyectoFactoringId: number;
  oportunidadFactoring: OportunidadFactoring;

  constructor(
    private _platformService: PlatformService,
    private _proyectosHomeService: ProyectosHomeService,
  ) { }

  ngOnInit(): void
  {
    this.isPlatformFactoring = DOMAIN_ENVIRONMENT[this._platformService._domainEnvironment] == 'FACTORING' ? true : false;
    this.domainUrl = this._platformService.getSubdominioUrl('factoring');
    this.getOperacionFactoring();
  }

  private getOperacionFactoring(): void
  {
    this.isLoading = true;
    this._proyectosHomeService.getProyectosHome('factoring').subscribe({
      next: (r) =>
      {
        this.isLoading = false;
        this.proyectoFactoringId = r.proyectoId;
      },
      complete: () => { 
        this.proyectoFactoringId > 0 && this.getOportunidadFactoring() 
      },
      error: () =>
      {
        this.isLoading = false;
      }
    });
  }

  private getOportunidadFactoring(): void
  {
    this.isLoading = true;
    this._proyectosHomeService.getProyectoFactoring(this.proyectoFactoringId).subscribe({
      next: (r) =>
      {
        this.isLoading = false;
        this.oportunidadFactoring = r;
        if (this.oportunidadFactoring.nombreOperacion.length > 30)
        {
          this.oportunidadFactoring.nombreOperacionShort = this.oportunidadFactoring.nombreOperacion.substring(0, 20) + '...';
        }
      },
      error: () =>
      {
        this.isLoading = false;
      }
    });
  }
}

